<template>
  <RouterView />
</template>

<script>
export default {
  name: "App",
  mounted() {
    // 1.禁用右键菜单
    document.oncontextmenu = new Function("event.returnValue=false");
    // 2.禁用鼠标选中
    document.onselectstart = new Function("event.returnValue=false");
  },
};
</script>

<style>
body {
  padding: 0;
  margin: 0;
}
#app {
  height: 100vh;
  width: 100%;
  overflow: auto;
}
</style>
